(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscriber-video-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSoulLibrarySection(section) {
    if (!section || section.dataset.soulLibraryBound === 'true') return;
    section.dataset.soulLibraryBound = 'true';

    const grid = section.querySelector('[data-video-grid]');
    const cards = Array.from(section.querySelectorAll('[data-card]'));

    const filterList = section.querySelector('[data-filter-list]');
    const filterEmpty = section.querySelector('[data-filter-empty]');
    const activeChipsHost = section.querySelector('[data-active-chips]');
    const clearButton = section.querySelector('[data-clear-filters]');
    const resultsCount = section.querySelector('[data-results-count]');
    const activeCount = section.querySelector('[data-active-count]');
    const sortSelect = section.querySelector('[data-sort-select]');
    const noResults = section.querySelector('[data-no-results]');

    const accessModal = section.querySelector('[data-access-modal]');
    const openAccessButtons = Array.from(section.querySelectorAll('[data-open-access-modal]'));
    const closeAccessButtons = Array.from(section.querySelectorAll('[data-close-access-modal]'));
    const modalVideoTitle = section.querySelector('[data-modal-video-title]');
    const loginLinks = Array.from(section.querySelectorAll('[data-login-link]'));
    const loginBase = section.dataset.loginBase || '/account/login';

    const videoModal = section.querySelector('[data-video-modal]');
    const videoModalContent = section.querySelector('[data-video-modal-content]');
    const closeVideoModalBtn = section.querySelector('[data-close-video-modal]');

    function buildLoginHref() {
      const current = `${window.location.pathname}${window.location.search}${window.location.hash || `#${section.id}`}`;
      return `${loginBase}?return_to=${encodeURIComponent(current)}`;
    }

    function syncLoginLinks() {
      if (loginLinks.length === 0) return;
      const href = buildLoginHref();
      loginLinks.forEach((link) => link.setAttribute('href', href));
    }

    function openAccessModal(videoTitle) {
      if (!accessModal) return;

      syncLoginLinks();

      if (modalVideoTitle) {
        const hasTitle = Boolean(videoTitle);
        modalVideoTitle.hidden = !hasTitle;
        if (hasTitle) modalVideoTitle.textContent = videoTitle;
      }

      if (typeof accessModal.showModal === 'function') {
        if (!accessModal.open) accessModal.showModal();
      } else {
        accessModal.setAttribute('open', 'open');
      }
    }

    function closeAccessModal() {
      if (!accessModal) return;
      if (typeof accessModal.close === 'function') {
        if (accessModal.open) accessModal.close();
      } else {
        accessModal.removeAttribute('open');
      }
    }

    function openVideoModalFromCard(card) {
      if (!videoModal || !videoModalContent || !card) return;
      const template = card.querySelector('[data-video-modal-template]');
      if (!template) return;

      videoModalContent.innerHTML = template.innerHTML;

      if (typeof videoModal.showModal === 'function') {
        if (!videoModal.open) videoModal.showModal();
      } else {
        videoModal.setAttribute('open', 'open');
      }
    }

    function closeVideoModal() {
      if (!videoModal) return;

      if (typeof videoModal.close === 'function') {
        if (videoModal.open) videoModal.close();
      } else {
        videoModal.removeAttribute('open');
      }

      if (videoModalContent) videoModalContent.innerHTML = '';
    }

    if (accessModal) {
      accessModal.addEventListener('click', (e) => {
        if (e.target === accessModal) closeAccessModal();
      });
    }

    if (videoModal) {
      videoModal.addEventListener('click', (e) => {
        if (e.target === videoModal) closeVideoModal();
      });
    }

    closeAccessButtons.forEach((btn) => btn.addEventListener('click', closeAccessModal));
    openAccessButtons.forEach((btn) => btn.addEventListener('click', () => openAccessModal(btn.dataset.videoTitle || '')));

    if (closeVideoModalBtn) closeVideoModalBtn.addEventListener('click', closeVideoModal);

    if (!grid || cards.length === 0) return;

    section.addEventListener(
      'click',
      (event) => {
        if (event.target.closest('[data-open-access-modal]')) return;

        const media = event.target.closest('.soul-card__media');
        if (!media) return;

        const card = media.closest('[data-card]');
        if (!card) return;

        if (card.classList.contains('soul-card--locked')) return;

        openVideoModalFromCard(card);
      },
      true
    );

    const selectedCategories = new Set();
    const categoryMap = new Map();

    cards.forEach((card) => {
      const key = (card.dataset.category || '').trim();
      const label = (card.dataset.categoryLabel || key).trim();
      if (!key) return;
      if (!categoryMap.has(key)) categoryMap.set(key, label);
    });

    function renderFilterButtons() {
      if (!filterList) return;
      filterList.innerHTML = '';

      const entries = Array.from(categoryMap.entries()).sort((a, b) => a[1].localeCompare(b[1]));

      if (entries.length === 0) {
        if (filterEmpty) filterEmpty.hidden = false;
        return;
      }

      if (filterEmpty) filterEmpty.hidden = true;

      entries.forEach(([key, label]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'soul-library__filter-button';
        button.dataset.filterValue = key;
        button.setAttribute('aria-pressed', 'false');
        button.innerHTML = `<span>${label.toUpperCase()}</span><span class="soul-library__filter-icon" aria-hidden="true">+</span>`;

        button.addEventListener('click', () => {
          if (selectedCategories.has(key)) selectedCategories.delete(key);
          else selectedCategories.add(key);
          applyFiltersAndSort();
        });

        filterList.appendChild(button);
      });
    }

    function syncFilterButtons() {
      if (!filterList) return;

      filterList.querySelectorAll('[data-filter-value]').forEach((button) => {
        const key = button.dataset.filterValue;
        const active = selectedCategories.has(key);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const icon = button.querySelector('.soul-library__filter-icon');
        if (icon) icon.textContent = active ? 'x' : '+';
      });
    }

    function renderActiveChips() {
      if (!activeChipsHost) return;
      activeChipsHost.innerHTML = '';

      selectedCategories.forEach((key) => {
        const label = categoryMap.get(key) || key;
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'soul-library__active-chip';
        chip.innerHTML = `${label} <span aria-hidden="true">&times;</span>`;
        chip.addEventListener('click', () => {
          selectedCategories.delete(key);
          applyFiltersAndSort();
        });
        activeChipsHost.appendChild(chip);
      });
    }

    function sortCards(visibleCards) {
      const sortValue = sortSelect ? sortSelect.value : 'newest';
      const sortedCards = [...visibleCards];

      sortedCards.sort((a, b) => {
        if (sortValue === 'title') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        if (sortValue === 'duration_asc') return (Number(a.dataset.duration) || 0) - (Number(b.dataset.duration) || 0);
        if (sortValue === 'duration_desc') return (Number(b.dataset.duration) || 0) - (Number(a.dataset.duration) || 0);
        if (sortValue === 'oldest') return (Number(a.dataset.order) || 0) - (Number(b.dataset.order) || 0);
        return (Number(b.dataset.order) || 0) - (Number(a.dataset.order) || 0);
      });

      return sortedCards;
    }

    function applyFiltersAndSort() {
      const visibleCards = cards.filter((card) => {
        if (selectedCategories.size === 0) return true;
        const cardCategory = (card.dataset.category || '').trim();
        return selectedCategories.has(cardCategory);
      });

      cards.forEach((card) => (card.hidden = true));

      sortCards(visibleCards).forEach((card) => {
        card.hidden = false;
        grid.appendChild(card);
      });

      if (resultsCount) resultsCount.textContent = String(visibleCards.length);
      if (activeCount) activeCount.textContent = String(selectedCategories.size);
      if (clearButton) clearButton.hidden = selectedCategories.size === 0;
      if (noResults) noResults.hidden = visibleCards.length !== 0;

      syncFilterButtons();
      renderActiveChips();
    }

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        selectedCategories.clear();
        applyFiltersAndSort();
      });
    }

    if (sortSelect) sortSelect.addEventListener('change', applyFiltersAndSort);

    renderFilterButtons();
    applyFiltersAndSort();
  }

  document.querySelectorAll('[data-soul-library-id]').forEach(initSoulLibrarySection);
})();

  } catch(e) { console.error(e); }
})();
})();
